import { httpRequest } from "@/lib";
import { RoleResponse } from "@/types";
import { useQuery } from "@tanstack/react-query";

type Props = {
  page?: string;
  search?: string;
};

async function fetchRoles({
  page = "1",
  search = "",
}: Props): Promise<RoleResponse> {
  const response = await httpRequest.get<RoleResponse>(
    `/positions?page=${page}&search=${search}`
  );
  return response.data;
}

export function useFetchRolesQuery({ page = "1", search = "" }: Props) {
  // SPEC-NAV-01 §5: the key was `["positions"]` for every page and every
  // search, so the list page compensated with `setTimeout(refetch)` and an
  // invalidation after a quick-create was not observable.
  const positionsQuery = useQuery({
    queryKey: ["positions", page, search],
    queryFn: () => fetchRoles({ page, search }),
    keepPreviousData: true,
  });

  return {
    ...positionsQuery,
    data: positionsQuery.data,
  };
}
